module.exports = __webpack_public_path__ + "img/questionnaire-image-fr.07cdca2b.jpg";